import Vue from 'vue';
import Vuex from 'vuex';
// import {get } from 'https';
Vue.use(Vuex);

const state = {
    customerId: sessionStorage.getItem('customerId'),
    buildingId: sessionStorage.getItem('buildingId'),
    buildId: sessionStorage.getItem('buildId'),
    analyBuildingId: sessionStorage.getItem('analyBuildingId'),
    analyCustomerId: sessionStorage.getItem('customerId'),
    leftMonitorInfo: JSON.parse(sessionStorage.getItem('leftData')),
    pointData: JSON.parse(sessionStorage.getItem('pointData')),
    floorList: JSON.parse(sessionStorage.getItem('floorData')),
    rightList: JSON.parse(sessionStorage.getItem('rightList')),
    leftoggle: JSON.parse(sessionStorage.getItem('leftoggle')),
    btnShow: JSON.parse(sessionStorage.getItem('btnShow')),
    reddata: JSON.parse(sessionStorage.getItem('reddata')),
    saveBtn: JSON.parse(sessionStorage.getItem('saveBtn')),
    editBulitData: sessionStorage.getItem('editBulitData') != '' && sessionStorage.getItem('editBulitData') != null ? JSON.parse(sessionStorage.getItem('editBulitData')) : '',
    navAddShow: JSON.parse(sessionStorage.getItem('navAddShow')),
    navTopMsg: '',
    menuS: sessionStorage.getItem('menuS'),
    menuS2Change: sessionStorage.getItem('menuS2Change'),
    floorListIndexL1: '',
    listenerIsWarn: '',
    routerUrl: '',
    sum: 0,
    isDot: false,
    showPopoverContent: false,
    isMsg: false,
    routerUrlName: '',
    bigScreenBuildingId: '',
}

const getters = {
    leftData(state) {
        return state.leftMonitorInfo
    },
    rightPointData(state) {
        return state.pointData
    },
    rightListShow(state) {
        return state.rightList
    },
}

const mutations = {
    getLeftData(state, data) {
        state.leftMonitorInfo = data
    },
    getDifferentiate(state, data) {
        state.differentiate = data
    },
    getPointData(state, data) {
        state.pointData = data
    },

}

const actions = {
    getLeftDataList(context, data) {
        context.commit('getLeftData', data)
    },
    getRightPoint(context, data) {
        context.commit('getPointData', data)
    }
}

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js